function trimTrailingSlash(url) {
    if (url !== '/' && url.slice(-1) === '/') return url.slice(0, -1)
    return url
}

export { trimTrailingSlash }
